import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowSquareLeft, ArrowSquareRight, TickCircle } from 'iconsax-react';
import { Tabs, Tab } from 'react-tabs-scrollable'
import 'react-tabs-scrollable/dist/rts.css'
import "../edit-card/mui-tabs.css";
import { useParams } from 'react-router';

const CardSelector = ({ card, onChange, cards }) => {
    // define state with initial value to let the tabs start with that value
    const [activeTab, setActiveTab] = useState(-1);
    const { all } = useParams();

    // define a onClick function to bind the value on tab click
    const onTabClick = (e, index) => {
        setActiveTab(index)
    }

    useEffect(() => {
        if (all) {
            setActiveTab(0);
        } else {
            const c = cards.find(i => i._id === card);
            const index = cards.indexOf(c);
            setActiveTab(index);
        }

    }, [all, card, cards])


    return (
        <Box sx={{ mt: '18px' }}>
            <Tabs
                activeTab={activeTab}
                onTabClick={onTabClick}
                rightBtnIcon={
                    <ArrowSquareRight
                        size="32"
                        variant="Bulk"
                    />
                }
                leftBtnIcon={
                    <ArrowSquareLeft
                        size="32"
                        variant="Bulk"
                    />
                }
                hideNavBtns={false}
                hideNavBtnsOnMobile={false}
                showTabsScroll={false}
            >
                {cards.map((item) => (
                    <Tab key={item._id} onClick={() => onChange(item._id)}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography fontSize={14} sx={{ mr: 1 }}>{item.name}</Typography>

                            {item.default &&
                                <TickCircle size="20" variant="Bold" />
                            }
                        </Box>
                    </Tab>
                ))}
            </Tabs>
        </Box>
    );
};

export default CardSelector;

